module.exports = __webpack_public_path__ + "img/v1-0.e55ed9b9.png";